import { useIntl } from "react-intl";

export function useLocale(): string {
    const intl = useIntl();
    return intl.locale;
}
